<template>
  <div>

   <iframe src="https://docs.google.com/document/d/e/2PACX-1vQt6BVnT_UdIt0aiRUfbqdniGHGv7dcF-QI2jAnyQue0cwKKXbf52kepHRSmXxON7e84luxM2lMwe62/pub?embedded=true" width="100%" height="650px"></iframe>   

  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>